import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= action import section ========= //
import {
  doFetchCurrencyRate,
  doFetchProfile,
  doSignOut,
  doUpdateProfile,
  updateUserCountry,
} from '../../actions/authAction';
import {
  doBuyCompletions,
  historyPayments,
} from '../../actions/dashboardAction';
import {
  doDisbursement,
  getDisbursementSetting,
} from '../../actions/disbursementAction';
import { getUserPoint } from '../../actions/kickPointAction';
import {
  doFetchCountries,
  doFetchProvinces,
  doFetchUserBankAccount,
  getHistoryShipping,
} from '../../actions/postalCodeAction';
import { doTopUp } from '../../actions/topUpAction';
import {
  convertToRupiah,
  getCloudImageUrl,
  formatCurrencyWithMinus,
} from '../../utils';
import { RESOURCE_URL } from '../../config';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import AuthInterface from '../../interface/reducers/auth';
import RouteHistoryInterface from '../../interface/router';
// ====== end of interface import section ====== //

import TopupForm from './Modals/TopupForm';
import CashoutForm from './Modals/CashoutForm';
import UserBalanceInfoModal from './Modals/UserBalanceInfoModal';

import DEFAULT_PROFILE from '../../images/profile-default.png';
import ModalForeignLocation from './components/ModalForeignLocation';
import VerifiedIcon from 'images/survey-check.png';
import ModalUnverifiedUser from 'Pages/Home/Components/Organisms/ModalUnverifiedUser';
const userBalanceIcon = `${RESOURCE_URL}icons/kickcredit.png`;

type stateToProps = {
  dataAuth: AuthInterface;
  dataHistory: any;
  dataTopUp: any;
  dataPostalCode: {
    userBankAccount: any;
    updatedUserBankAccount: any;
    countries: any;
    provinces: any;
  };
  dataDisbursement: any;
  dataKickPoint: {
    userPoint: any;
  };
  dataUserBankAccount: any;
  dataMenu: any;
};

interface userDashboard extends stateToProps {
  history: RouteHistoryInterface;
  dataUserPoint: any;
  routes: any;
  countdown_modal?: boolean;
  signOut: () => any;
  doTopUp: (payload: any) => Promise<any>;
  doDisbursement: (payload: any) => Promise<any>;
  getProfile: () => Promise<any>;
}

const userDashboardMenu = [
  {
    text: 'Buying Dashboard',
    route: 'order',
    isLogout: false,
  },
  {
    text: 'Selling Dashboard',
    route: 'sale',
    isLogout: false,
  },
  {
    text: 'Consignment Dashboard',
    route: 'consignment',
    isLogout: false,
  },
  {
    text: 'My Voucher',
    route: 'rewards',
    isLogout: false,
  },
  {
    text: 'Settings',
    route: 'profile-settings',
    isLogout: false,
  },
  {
    text: 'Logout',
    route: 'logout',
    isLogout: true,
  },
];

/**
 * User Dashboard page for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {userDashboard} props for this component.
 * @return {JSX.Element}
 */
function UserDashboard({
  history,
  dataAuth,
  dataUserPoint,
  signOut,
  dataUserBankAccount,
  doDisbursement,
  doTopUp,
  dataTopUp,
  dataDisbursement,
  getProfile,
  countdown_modal,
  ...props
}: userDashboard): JSX.Element {
  const isSellerCreditMinus =
    parseInt(dataAuth?.userdata?.balance_with_fee ?? '0') < 0;

  const [isOpenCashOut, setToggleCashOut] = useState(false);
  const [isOpenTopUp, setToggleTopUp] = useState(false);
  const [isOpenSellerInfo, onSellerInfoToggle] = useState(false);

  const [isOpenForeignModal, onForeignModalToggle] = useState(false);
  const [dashboardMenu, setDashboardMenu] = useState(userDashboardMenu);

  const isSeller = dataAuth.userdata.roles.some((role) =>
    role.includes('seller'),
  );
  const isNewUser =
    !dataAuth.userdata.seller_verification_info?.length && !isSeller;

  useEffect(() => {
    if (!dataAuth.isLogged) {
      history.push('/');
    }
    if (window.innerWidth > 1095) {
      history.push('/user_dashboard/profile-settings');
    }
  }, []);

  useEffect(() => {
    if (dataAuth.userdata.country_code !== 'IDN') {
      setDashboardMenu(
        userDashboardMenu.filter((item) => item.route !== 'sale'),
      );
    } else {
      setDashboardMenu(userDashboardMenu);
    }
  }, [dataAuth.userdata]);

  /**
   * Change URL function to handle clicked navigation menu
   * @param {string} target url route.
   * @param {boolean} isLogout condition if this was a logout button.
   */
  function _changeUrl(target: string, isLogout: boolean) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    if (isLogout) {
      signOut();
      history.replace('');
      return;
    }
    history.push({ pathname: `/user_dashboard/${target}` });
  }

  function handleCashOutSubmit(payloads) {
    doDisbursement(payloads).then(() => {
      getProfile();
    });
  }

  function handleTopUpSubmit(payloads) {
    doTopUp(payloads);
  }
  const tierImage = () => {
    const tierLabel = dataUserPoint.data && dataUserPoint.data.tier_label;

    switch (tierLabel) {
      case 'bronze':
        return 'https://kickavenue-assets.s3.amazonaws.com/kick-points-tier/bronze.png';
      case 'silver':
        return 'https://kickavenue-assets.s3.amazonaws.com/kick-points-tier/silver.png';
      case 'gold':
        return 'https://kickavenue-assets.s3.amazonaws.com/kick-points-tier/gold.png';
      case 'platinum':
        return 'https://kickavenue-assets.s3.amazonaws.com/kick-points-tier/platinum.png';

      default:
        return 'https://kickavenue-assets.s3.amazonaws.com/kick-points-tier/bronze.png';
    }
  };

  const userCountry = dataAuth.userdata.country_code || 'IDN';

  const firstName =
    dataAuth.userdata.first_name !== null ? dataAuth.userdata.first_name : '';
  const lastName =
    dataAuth.userdata.family_name !== null ? dataAuth.userdata.family_name : '';
  const holdBalance =
    parseInt(dataAuth.userdata.current_balance) -
    parseInt(dataAuth.userdata.balance);

  const [isShowModal, setIsShowModal] = useState(false);
  const [unverifiedType, setUnverifiedType] =
    useState<
      'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account'
    >('Top Up');

  const onClickUnverifiedUser = (
    val: 'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account',
  ) => {
    setIsShowModal(true);
    setUnverifiedType(val);
  };

  return (
    <div
      className={
        countdown_modal
          ? 'page-container is-countdown-active'
          : 'page-container'
      }
      id={'dashboard-container-mobile'}
    >
      <div className={'container'}>
        <div className={'menu'}>
          <div className={'main-card'}>
            <div className={'user-information'}>
              <KickImage
                src={
                  dataAuth.userdata.img_url
                    ? dataAuth.userdata.img_url
                    : DEFAULT_PROFILE
                }
                className={'profile-photo'}
              />
              <div className={'profile-info'}>
                <h5>{firstName + ' ' + lastName}</h5>
                <h6>{dataAuth.userdata.typed_email}</h6>

                {!isNewUser &&
                  dataAuth.userdata.seller_verification_status ===
                    'unverified' && (
                    <span className="profile-status-unverified">
                      Unverified Seller
                    </span>
                  )}

                {!isNewUser &&
                  dataAuth.userdata.seller_verification_status ===
                    'verified' && (
                    <span className="profile-status-verified">
                      Verified Seller
                      <KickImage
                        src={VerifiedIcon}
                        width={12}
                        height={12}
                        style={{ marginLeft: 4 }}
                      />
                    </span>
                  )}
              </div>
            </div>

            {userCountry && userCountry === 'IDN' && (
              <div className={'credit-info'}>
                <div className={'credit-card-container'}>
                  <div
                    className={'kick-credit-container'}
                    onClick={() => _changeUrl('wallet-history', false)}
                  >
                    <span className={'title'}>Kick Credit</span>
                    <span className={'balance'}>Balance</span>
                    <span className={'balance-value'}>
                      {convertToRupiah(parseInt(dataAuth.userdata.balance))}
                    </span>
                    <div className={'kick-points-container'}>
                      <span className={'title'}>Kick Points</span>
                      <span className={'value'}>
                        {convertToRupiah(
                          parseInt(dataAuth.userdata.locked_balance),
                        )}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`seller-credit-container ${
                      isSellerCreditMinus ? 'credit-minus' : ''
                    }`}
                    onClick={() => _changeUrl('seller-history', false)}
                  >
                    <span className={'title'}>Seller Credit</span>
                    <span className={'balance'}>Balance</span>
                    <span
                      className={`balance-value ${
                        parseInt(dataAuth?.userdata?.balance_with_fee) < 0
                          ? 'minus'
                          : ''
                      }`}
                    >
                      {formatCurrencyWithMinus(
                        parseInt(dataAuth?.userdata?.balance_with_fee),
                        props.ratio,
                        props.currency,
                      )}
                    </span>
                    <span
                      className={'credit-seller-info'}
                      onClick={() => onSellerInfoToggle(!isOpenSellerInfo)}
                    >
                      What is Seller Credit?
                    </span>
                  </div>
                </div>

                <div className={'credit-action'}>
                  <div
                    className={'top-up-container'}
                    onClick={() => {
                      if (dataAuth.userdata.roles.includes('unverified_user')) {
                        onClickUnverifiedUser('Top Up');
                        return;
                      }
                      setToggleTopUp(!isOpenTopUp);
                    }}
                  >
                    <div className={'img-icon'} />
                    <span>Top Up</span>
                  </div>
                  <div
                    className={'cash-out-container'}
                    onClick={() => {
                      if (dataAuth.userdata.roles.includes('unverified_user')) {
                        onClickUnverifiedUser('Cash Out');
                        return;
                      }
                      setToggleCashOut(!isOpenCashOut);
                    }}
                  >
                    <div className={'img-icon'} />
                    <span>Cash Out</span>
                  </div>
                </div>
              </div>
            )}

            <div className={'navigation-menu'}>
              <div className={'reward-container'}>
                <KickImage src={getCloudImageUrl(tierImage(), 300)} />
                <div className={'text-container'}>
                  <p className={'top'}>Kick Rewards</p>
                  <p className={'bottom'}>
                    {dataUserPoint.data && dataUserPoint.data.tier_label
                      ? dataUserPoint.data && dataUserPoint.data.tier_label
                      : 'Bronze'}
                  </p>
                </div>
              </div>
              {dashboardMenu.map((t) => {
                let divClass;
                const isActive =
                  history.location.pathname.split('/')[2] === t.route;

                // Condition for differentiate between logout and normal button
                if (t.isLogout) {
                  divClass = 'menu-item-logout';
                } else {
                  divClass = 'menu-item';
                }

                // Condition if the current menu is active
                if (isActive) divClass += ' active';

                return (
                  <div
                    key={t.route}
                    className={divClass}
                    onClick={() => {
                      if (
                        !dataAuth.userdata.seller_verification &&
                        t.route === 'sale' &&
                        dataAuth.userdata.country_code === 'IDN' &&
                        dataAuth.userdata.roles.includes('seller')
                      ) {
                        history.push({ pathname: `/seller-registration` });
                        return;
                      }

                      if (
                        t.route === 'sale' &&
                        dataAuth.userCurrency.currency !== 'IDR'
                      ) {
                        onForeignModalToggle(!isOpenForeignModal);
                        return;
                      }
                      if (!isActive) _changeUrl(t.route, t.isLogout);
                    }}
                  >
                    {t.text}
                  </div>
                );
              })}
            </div>
            <CashoutForm
              title="Kick Credit"
              balance_source="BALANCE"
              amountFee={0}
              icon={getCloudImageUrl(userBalanceIcon, 400)}
              isOpen={isOpenCashOut}
              onToggle={() => setToggleCashOut(!isOpenCashOut)}
              onSubmit={handleCashOutSubmit}
              balance={dataAuth.userdata.balance}
              bankAccount={dataUserBankAccount.data}
              dataDisburse={dataDisbursement.disbursement}
              dataPassword={dataUserBankAccount.data.have_password}
              history={history}
              hasOptions
            />
            <TopupForm
              title="Kick Credit"
              isOpen={isOpenTopUp}
              onToggle={() => setToggleTopUp(!isOpenTopUp)}
              onSubmit={handleTopUpSubmit}
              dataTopUp={dataTopUp.topUp}
              balance={dataAuth.userdata.balance}
              holdBalance={holdBalance}
              icon={getCloudImageUrl(userBalanceIcon, 400)}
            />
            <UserBalanceInfoModal
              isOpen={isOpenSellerInfo}
              onToggle={() => onSellerInfoToggle(!isOpenSellerInfo)}
              cashOutFee={
                dataDisbursement?.disbursementSetting?.cashout_fee ?? 0
              }
              adminFee={dataDisbursement?.disbursementSetting?.admin_fee ?? 0}
            />
            <ModalForeignLocation
              isOpen={isOpenForeignModal}
              onToggle={() => onForeignModalToggle(!isOpenForeignModal)}
            />
            <ModalUnverifiedUser
              type={unverifiedType}
              isShow={isShowModal}
              setIsShow={setIsShowModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataAuth: state.dataAuth,
    dataHistory: state.dataHistory,
    dataTopUp: state.dataTopUp,
    dataUserBankAccount: state.dataPostalCode.userBankAccount,
    dataUpdatedUserBankAccount: state.dataPostalCode.updatedUserBankAccount,
    dataDisbursement: state.dataDisbursement,
    dataShipping: state.dataPostalCode,
    dataUserPoint: state.dataKickPoint.userPoint,
    countries: state.dataPostalCode.countries,
    provinces: state.dataPostalCode.provinces,
    currency: state.dataAuth.userCurrency.currency,
    ratio: state.dataAuth.userCurrency.ratio,
    countdown_modal: state.dataMenu.countdown_modal,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    getHistoryPayments: () => dispatch(historyPayments()),
    getProvinces: (country: any) => dispatch(doFetchProvinces(country)),
    fetchHistoryShipping: () => dispatch(getHistoryShipping()),
    getUserBankAccount: () => dispatch(doFetchUserBankAccount()),
    buyCompletions: (id: number) => dispatch(doBuyCompletions(id)),
    signOut: () => dispatch(doSignOut()),
    doTopUp: (payload: any) => dispatch(doTopUp(payload)),
    doDisbursement: (payload: any) => dispatch(doDisbursement(payload)),
    getProfile: () => dispatch(doFetchProfile()),
    getCurrencyRate: (payload: any) => dispatch(doFetchCurrencyRate(payload)),
    fetchUserPoint: () => dispatch(getUserPoint()),
    updateProfile: (payload: any) => dispatch(doUpdateProfile(payload)),
    // doFetchOfferHistory: (payload) => dispatch(doFetchOfferHistory(payload))
    getCountries: () => dispatch(doFetchCountries()),
    doUpdateUserCountry: (payload: any) => dispatch(updateUserCountry(payload)),
    fetchDisbursementSetting: () => dispatch(getDisbursementSetting()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDashboard);
